/* =========================================================================
   Font Cut Studio — assets/font-cut-studio.js (bearly.art)
   Runs on the Bearly Tools shell (sections/font-cut-studio.liquid).
   Needs opentype.js + paper.js (loaded by the section, deferred, before this file).
   Tracking: fc_* events via BT.track (shared core sends them to GA4);
   fc_tool_view / fc_related_click / fc_back_click come from the core.
   Download popup + email gate: the ONE shared popup in the core (BT.runWithProgress):
   progress (this tool's stage texts), email step only if not unlocked, then the file
   (download). The core owns the popup, gate, Klaviyo subscribe, unlock keys,
   export-error toast and the fc_email_* / fc_progress_cancel / fc_export_error events.
   Old core cached (no runWithProgress): the export runs straight away.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.getElementById('fontcut-root');
  if (!root) return;

  var TOOL = { name: 'Font Cut Studio', handle: 'font-cut-studio' };
  var SVGNS = 'http://www.w3.org/2000/svg';
  var $ = function (id) { return document.getElementById(id); };

  /* ---------------- tracking + Klaviyo (per-tool events via the core) ---------------- */
  function track(name, params) {
    if (window.BT && typeof window.BT.track === 'function') { window.BT.track(name, params || {}); return; }
    var o = Object.assign({ event: 'fc_' + name.replace(/^fc_/, '') }, params || {});
    (window.dataLayer = window.dataLayer || []).push(o);
  }

  function klaviyoEvent(name, props) {
    if (window.BT && typeof window.BT.klaviyoEvent === 'function') window.BT.klaviyoEvent(name, props);
  }

  var started = false;
  function markStarted(props) {
    if (started) return;
    started = true;
    klaviyoEvent('Started ' + TOOL.name, props);
  }

  /* ---------------- curated catalog: open-licence Google Fonts, plain-language tags ---------------- */
  var TAGS = {
    chunky: 'Chunky & bold', script: 'Fancy script', handwritten: 'Handwritten',
    clean: 'Clean & simple', elegant: 'Elegant', playful: 'Playful & fun',
    rounded: 'Soft & rounded', tall: 'Tall & skinny', vintage: 'Vintage & retro',
    slab: 'Sturdy slab', typewriter: 'Typewriter', stencil: 'Stencil', seasonal: 'Seasonal'
  };

  var FONTS = [
    // chunky & bold
    {n:'Anton',t:['chunky','tall']},{n:'Archivo Black',t:['chunky']},{n:'Bebas Neue',t:['chunky','tall']},
    {n:'Passion One',t:['chunky']},{n:'Titan One',t:['chunky','playful','rounded']},{n:'Bungee',t:['chunky','playful']},
    {n:'Black Ops One',t:['chunky','stencil']},{n:'Alfa Slab One',t:['chunky','slab','vintage']},
    {n:'Ultra',t:['chunky','slab','vintage']},{n:'Luckiest Guy',t:['chunky','playful']},
    {n:'Shrikhand',t:['chunky','vintage']},{n:'Lilita One',t:['chunky','playful','rounded']},
    {n:'Fredoka',t:['rounded','playful','clean']},{n:'Chewy',t:['playful','rounded']},
    {n:'Sigmar One',t:['chunky','playful']},{n:'Concert One',t:['chunky','rounded']},
    {n:'Changa One',t:['chunky']},{n:'Bowlby One SC',t:['chunky','playful']},
    {n:'Modak',t:['chunky','rounded','playful']},{n:'Bungee Shade',t:['chunky','vintage']},
    {n:'Rammetto One',t:['chunky','playful']},{n:'Abril Fatface',t:['chunky','elegant','vintage']},
    // clean & simple
    {n:'Roboto',t:['clean']},{n:'Open Sans',t:['clean']},{n:'Lato',t:['clean']},{n:'Montserrat',t:['clean']},
    {n:'Poppins',t:['clean','rounded']},{n:'Raleway',t:['clean','elegant']},{n:'Nunito',t:['clean','rounded']},
    {n:'Inter',t:['clean']},{n:'Work Sans',t:['clean']},{n:'Quicksand',t:['clean','rounded']},
    {n:'Josefin Sans',t:['clean','elegant','vintage']},{n:'Oswald',t:['clean','tall']},
    {n:'Barlow',t:['clean']},{n:'Rubik',t:['clean','rounded']},{n:'Karla',t:['clean']},
    {n:'DM Sans',t:['clean']},{n:'Cabin',t:['clean']},{n:'Barlow Condensed',t:['clean','tall']},
    {n:'Archivo Narrow',t:['clean','tall']},{n:'Yanone Kaffeesatz',t:['clean','tall']},
    {n:'Six Caps',t:['tall']},{n:'Pathway Gothic One',t:['tall','clean']},
    // fancy script
    {n:'Great Vibes',t:['script','elegant']},{n:'Allura',t:['script','elegant']},{n:'Alex Brush',t:['script']},
    {n:'Dancing Script',t:['script']},{n:'Parisienne',t:['script','elegant']},{n:'Sacramento',t:['script']},
    {n:'Tangerine',t:['script','elegant']},{n:'Pinyon Script',t:['script','elegant','vintage']},
    {n:'Mr Dafoe',t:['script','vintage']},{n:'Yellowtail',t:['script','vintage']},{n:'Satisfy',t:['script']},
    {n:'Kaushan Script',t:['script']},{n:'Lobster',t:['script','vintage','chunky']},{n:'Lobster Two',t:['script','vintage']},
    {n:'Pacifico',t:['script','playful','vintage']},{n:'Cookie',t:['script']},{n:'Courgette',t:['script']},
    {n:'Norican',t:['script']},{n:'Italianno',t:['script','elegant']},{n:'Marck Script',t:['script','handwritten']},
    {n:'Grand Hotel',t:['script','vintage']},{n:'Berkshire Swash',t:['script','playful','vintage']},
    {n:'Oleo Script',t:['script','playful']},{n:'Playball',t:['script','vintage']},
    {n:'Mrs Saint Delafield',t:['script','elegant']},{n:'Rouge Script',t:['script','elegant']},
    // handwritten
    {n:'Caveat',t:['handwritten']},{n:'Shadows Into Light',t:['handwritten']},{n:'Indie Flower',t:['handwritten','playful']},
    {n:'Patrick Hand',t:['handwritten','playful']},{n:'Amatic SC',t:['handwritten','tall']},{n:'Handlee',t:['handwritten']},
    {n:'Kalam',t:['handwritten']},{n:'Gochi Hand',t:['handwritten','playful']},{n:'Coming Soon',t:['handwritten','playful']},
    {n:'Schoolbell',t:['handwritten','playful']},{n:'Neucha',t:['handwritten']},{n:'Nothing You Could Do',t:['handwritten']},
    {n:'Homemade Apple',t:['handwritten']},{n:'Reenie Beanie',t:['handwritten']},{n:'Rock Salt',t:['handwritten']},
    {n:'Permanent Marker',t:['handwritten','chunky']},{n:'Gloria Hallelujah',t:['handwritten','playful']},
    {n:'Architects Daughter',t:['handwritten']},{n:'Just Another Hand',t:['handwritten','tall']},
    {n:'Covered By Your Grace',t:['handwritten']},{n:'La Belle Aurore',t:['handwritten']},
    {n:'Cedarville Cursive',t:['handwritten']},{n:'Waiting for the Sunrise',t:['handwritten']},{n:'Zeyada',t:['handwritten']},
    {n:'Sriracha',t:['handwritten','playful']},
    // elegant serif
    {n:'Playfair Display',t:['elegant']},{n:'Cormorant Garamond',t:['elegant']},{n:'EB Garamond',t:['elegant']},
    {n:'Cinzel',t:['elegant','vintage']},{n:'Libre Baskerville',t:['elegant']},{n:'Lora',t:['elegant']},
    {n:'Crimson Text',t:['elegant']},{n:'Marcellus',t:['elegant']},{n:'Prata',t:['elegant']},
    {n:'Bodoni Moda',t:['elegant']},{n:'DM Serif Display',t:['elegant']},{n:'Spectral',t:['elegant']},
    {n:'Cardo',t:['elegant']},{n:'Cinzel Decorative',t:['elegant','vintage']},{n:'Yeseva One',t:['elegant','vintage']},
    // typewriter
    {n:'Courier Prime',t:['typewriter']},{n:'Special Elite',t:['typewriter','vintage']},{n:'Cutive Mono',t:['typewriter']},
    {n:'IBM Plex Mono',t:['typewriter','clean']},{n:'Space Mono',t:['typewriter']},{n:'JetBrains Mono',t:['typewriter','clean']},
    {n:'Roboto Mono',t:['typewriter','clean']},{n:'VT323',t:['typewriter','playful']},
    // vintage / retro / western
    {n:'Rye',t:['vintage','chunky']},{n:'Smokum',t:['vintage']},{n:'Monoton',t:['vintage','playful']},
    {n:'Righteous',t:['vintage','clean']},{n:'Fugaz One',t:['vintage','chunky']},{n:'Limelight',t:['vintage','elegant']},
    {n:'Poiret One',t:['vintage','elegant','clean']},{n:'Graduate',t:['vintage','slab']},
    {n:'Vast Shadow',t:['vintage','chunky']},{n:'Sancreek',t:['vintage']},
    {n:'Stardos Stencil',t:['stencil']},{n:'Allerta Stencil',t:['stencil','clean']},
    {n:'Ranchers',t:['playful','vintage']},{n:'Boogaloo',t:['playful']},
    {n:'Bubblegum Sans',t:['playful','rounded']},{n:'Sniglet',t:['playful','rounded']},{n:'Comic Neue',t:['playful']},
    // slab
    {n:'Arvo',t:['slab']},{n:'Zilla Slab',t:['slab','clean']},{n:'Roboto Slab',t:['slab','clean']},
    {n:'Bitter',t:['slab']},{n:'Crete Round',t:['slab','rounded']},{n:'Josefin Slab',t:['slab','vintage']},
    // rounded extras
    {n:'Comfortaa',t:['rounded','clean']},{n:'Varela Round',t:['rounded','clean']},{n:'Baloo 2',t:['rounded','playful']},
    // seasonal
    {n:'Mountains of Christmas',t:['seasonal','playful']},{n:'Creepster',t:['seasonal','chunky']},
    {n:'Henny Penny',t:['seasonal','playful']},{n:'Emilys Candy',t:['seasonal','playful','script']}
  ];

  /* ---------------- state ---------------- */
  var FS = 1000;                 // stage font size in px
  var state = {
    text: 'Hello',
    fontName: 'Pacifico',
    font: null,                  // opentype.Font
    fontExtras: [],              // extra css2 subset fonts (latin-ext, vietnamese…) for glyphs the main font lacks
    view: 'letters',             // letters | weld | parts
    spacing: 0,                  // px at FS
    sx: 1, sy: 1,
    sizeVal: 2, sizeUnit: 'in', sizeMode: 'cap',
    offsets: {},                 // letterIndex -> {dx,dy} in stage px
    disabledParts: new Set(),    // "letterIdx:partIdx"
    selLetter: -1,
    customFonts: []              // {n, font}
  };
  var fontCache = {};            // family -> opentype.Font | Promise
  var fontSrc = {};              // family -> 'ttf' | 'css2' | 'key' (how its outlines were loaded)
  var subsetCache = {};          // family + '|' + subset woff2 url -> opentype.Font | Promise
  var linkLoaded = new Set();    // css2 preview stylesheets added
  var weldCache = { d: '', key: '' };
  var activeTag = '';            // one style filter at a time ('' = all)

  /* ---------------- helpers ---------------- */
  var msgEl = $('fc-msg');
  function showMsg(text) {
    msgEl.textContent = text; msgEl.hidden = false;
    clearTimeout(showMsg.t); showMsg.t = setTimeout(function () { msgEl.hidden = true; }, 9000);
  }
  function toast(text) {
    if (window.BT && typeof window.BT.toast === 'function') window.BT.toast(text);
    else { msgEl.textContent = text; msgEl.hidden = false; clearTimeout(showMsg.t); showMsg.t = setTimeout(function () { msgEl.hidden = true; }, 4000); }
  }
  function getKey() { try { return localStorage.getItem('fc_gfKey') || localStorage.getItem('gfKey') || ''; } catch (e) { return window.__fcKey || ''; } }
  function setKey(v) { try { localStorage.setItem('fc_gfKey', v); } catch (e) { window.__fcKey = v; } }
  function unitToIn(v, u) { return u === 'in' ? v : u === 'cm' ? v / 2.54 : v / 25.4; }
  function fmt(v, u) { var x = u === 'in' ? v : u === 'cm' ? v * 2.54 : v * 25.4; return x.toFixed(2) + ' ' + u; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function accent() { return (getComputedStyle(root).getPropertyValue('--bt-accent') || '').trim() || '#4F5BD5'; }
  function libsReady() { return typeof window.opentype !== 'undefined' && typeof window.paper !== 'undefined'; }

  /* ---------------- font outline loading ----------------
     Route A: full static .ttf from the google/fonts repo on jsDelivr, pinned to one commit
              (all scripts the font has, no subsetting). Paths below were checked at that commit.
     Route B: css2 -> .woff2 + in-browser decoder (works everywhere, incl. Safari/iOS). Google
              splits these by script, so other subsets (latin-ext, vietnamese…) load on demand.
     Route C: official Web Fonts API with a user key.  Route D: file upload. */
  var FONT_BASE = 'https://cdn.jsdelivr.net/gh/google/fonts@23e54b51ddffbc7713c583748e3bd86f62b1fa4a/';
  // Default path: ofl/<family lowercase, no spaces>/<FamilyNoSpaces>-Regular.ttf.
  // Exceptions: a bare file name stays in ofl/<slug>/; a full path is used as-is.
  var TTF_PATH = {
    'Ultra':'apache/ultra/Ultra-Regular.ttf','Luckiest Guy':'apache/luckiestguy/LuckiestGuy-Regular.ttf',
    'Chewy':'apache/chewy/Chewy-Regular.ttf','Yellowtail':'apache/yellowtail/Yellowtail-Regular.ttf',
    'Satisfy':'apache/satisfy/Satisfy-Regular.ttf','Coming Soon':'apache/comingsoon/ComingSoon-Regular.ttf',
    'Schoolbell':'apache/schoolbell/Schoolbell-Regular.ttf','Homemade Apple':'apache/homemadeapple/HomemadeApple-Regular.ttf',
    'Rock Salt':'apache/rocksalt/RockSalt-Regular.ttf','Permanent Marker':'apache/permanentmarker/PermanentMarker-Regular.ttf',
    'Just Another Hand':'apache/justanotherhand/JustAnotherHand-Regular.ttf','Special Elite':'apache/specialelite/SpecialElite-Regular.ttf',
    'Smokum':'apache/smokum/Smokum-Regular.ttf','Roboto Slab':'apache/robotoslab/RobotoSlab[wght].ttf',
    'Mountains of Christmas':'apache/mountainsofchristmas/MountainsofChristmas-Regular.ttf',
    'Roboto':'Roboto[wdth,wght].ttf','Open Sans':'OpenSans[wdth,wght].ttf','Inter':'Inter[opsz,wght].ttf',
    'Work Sans':'WorkSans[wght].ttf','Oswald':'Oswald[wght].ttf','Karla':'Karla[wght].ttf','DM Sans':'DMSans[opsz,wght].ttf',
    'Cabin':'Cabin[wdth,wght].ttf','Archivo Narrow':'ArchivoNarrow[wght].ttf','Six Caps':'SixCaps.ttf',
    'Dancing Script':'DancingScript[wght].ttf','Caveat':'Caveat[wght].ttf','Shadows Into Light':'ShadowsIntoLight.ttf',
    'Neucha':'Neucha.ttf','Nothing You Could Do':'NothingYouCouldDo.ttf','Reenie Beanie':'ReenieBeanie.ttf',
    'Gloria Hallelujah':'GloriaHallelujah.ttf','Covered By Your Grace':'CoveredByYourGrace.ttf','La Belle Aurore':'LaBelleAurore.ttf',
    'Cedarville Cursive':'Cedarville-Cursive.ttf','Waiting for the Sunrise':'WaitingfortheSunrise.ttf','Zeyada':'Zeyada.ttf',
    'Playfair Display':'PlayfairDisplay[wght].ttf','EB Garamond':'EBGaramond[wght].ttf','Cinzel':'Cinzel[wght].ttf',
    'Libre Baskerville':'LibreBaskerville[wght].ttf','Lora':'Lora[wght].ttf','Bodoni Moda':'BodoniModa[opsz,wght].ttf',
    'JetBrains Mono':'JetBrainsMono[wght].ttf','Roboto Mono':'RobotoMono[wght].ttf','Comfortaa':'Comfortaa[wght].ttf',
    'Baloo 2':'Baloo2[wght].ttf'
  };
  // Variable fonts whose default weight isn't Regular (opentype.js draws the default, e.g. Montserrat
  // would come out Thin): css2 serves the real Regular instead.
  var CSS2_ONLY = ['Fredoka','Montserrat','Raleway','Nunito','Quicksand','Josefin Sans','Rubik',
    'Yanone Kaffeesatz','Cormorant Garamond','Bitter','Josefin Slab'];
  function ttfUrl(family) {
    if (CSS2_ONLY.indexOf(family) !== -1) return '';
    if (!FONTS.some(function (f) { return f.n === family; })) return '';
    var p = TTF_PATH[family] || (family.replace(/ /g, '') + '-Regular.ttf');
    if (p.indexOf('/') === -1) p = 'ofl/' + family.toLowerCase().replace(/[^a-z0-9]/g, '') + '/' + p;
    return FONT_BASE + p.replace(/\[/g, '%5B').replace(/\]/g, '%5D');
  }
  var woff2P = null;
  function loadWoff2Decoder() {
    if (woff2P) return woff2P;
    woff2P = new Promise(function (resolve, reject) {
      var settled = false;
      window.Module = window.Module || {};
      window.Module.onRuntimeInitialized = function () { settled = true; resolve(window.Module); };
      var urls = [
        'https://cdn.jsdelivr.net/npm/wawoff2@2.0.1/build/decompress_binding.js',
        'https://unpkg.com/wawoff2@2.0.1/build/decompress_binding.js'
      ];
      var i = 0;
      (function tryNext() {
        if (i >= urls.length) { if (!settled) reject(new Error('decoder unavailable')); return; }
        var sc = document.createElement('script');
        sc.src = urls[i++];
        sc.onerror = function () { sc.remove(); tryNext(); };
        document.head.appendChild(sc);
      })();
      setTimeout(function () { if (!settled) reject(new Error('decoder timeout')); }, 20000);
    });
    woff2P.catch(function () { woff2P = null; });
    return woff2P;
  }
  function woff2ToTTF(M, buf) {
    var out = M.decompress(new Uint8Array(buf));
    if (out instanceof Uint8Array) return out.buffer.slice(out.byteOffset, out.byteOffset + out.byteLength);
    if (out && typeof out.size === 'function') {
      var n = out.size(), u = new Uint8Array(n);
      for (var k = 0; k < n; k++) u[k] = out.get(k);
      if (out.delete) out.delete();
      return u.buffer;
    }
    throw new Error('decode failed');
  }

  async function fetchBuf(url) {
    var r = await fetch(url);
    if (!r.ok) throw new Error('http ' + r.status);
    return await r.arrayBuffer();
  }
  // css2 -> one entry per subset: { subset, url, ranges: [[from, to], …] }
  var cssCache = {};
  function css2Faces(family) {
    if (cssCache[family]) return cssCache[family];
    var fam = family.replace(/ /g, '+');
    var p = fetch('https://fonts.googleapis.com/css2?family=' + fam + '&display=swap').then(function (r) {
      if (!r.ok) throw new Error('css2 ' + r.status);
      return r.text();
    }).then(function (css) {
      var faces = [];
      var re = /(?:\/\*\s*([\w-]+)\s*\*\/\s*)?@font-face\s*\{([^}]*)\}/g, m;
      while ((m = re.exec(css))) {
        var u = m[2].match(/url\((https:[^)]+?\.woff2)\)/);
        if (!u) continue;
        var ranges = [];
        var ur = m[2].match(/unicode-range:\s*([^;}]+)/);
        if (ur) ur[1].split(',').forEach(function (part) {
          var q = part.trim().match(/^U\+([0-9A-F?]+)(?:-([0-9A-F]+))?$/i);
          if (!q) return;
          var a = parseInt(q[1].replace(/\?/g, '0'), 16);
          var b = q[2] ? parseInt(q[2], 16) : parseInt(q[1].replace(/\?/g, 'F'), 16);
          ranges.push([a, b]);
        });
        faces.push({ subset: m[1] || '', url: u[1], ranges: ranges });
      }
      if (!faces.length) throw new Error('no woff2 in css');
      return faces;
    });
    cssCache[family] = p;
    p.catch(function () { delete cssCache[family]; });
    return p;
  }
  async function woff2Font(url) {
    var raw = await fetchBuf(url);
    var M = await loadWoff2Decoder();
    return woff2ToTTF(M, raw);
  }
  async function fetchOutlineBuffer(family) {
    var url = ttfUrl(family);
    if (url) {
      try { return { buf: await fetchBuf(url), src: 'ttf' }; } catch (e) {}
    }
    try {
      var faces = await css2Faces(family);
      var latin = faces.filter(function (f) { return f.subset === 'latin'; })[0] || faces[faces.length - 1];
      return { buf: await woff2Font(latin.url), src: 'css2' };
    } catch (e) {}
    var key = getKey();
    if (key) {
      try {
        var r = await fetch('https://www.googleapis.com/webfonts/v1/webfonts?key=' + encodeURIComponent(key) + '&family=' + encodeURIComponent(family));
        if (r.ok) {
          var j = await r.json();
          var files = j.items && j.items[0] && j.items[0].files;
          if (files) {
            var u = (files.regular || Object.values(files)[0]).replace(/^http:/, 'https:');
            return { buf: await fetchBuf(u), src: 'key' };
          }
        }
      } catch (e) {}
    }
    throw new Error('no-route');
  }

  async function loadFont(family) {
    if (fontCache[family]) return fontCache[family];
    var p = (async function () {
      var got = await fetchOutlineBuffer(family);
      var f = opentype.parse(got.buf);
      fontSrc[family] = got.src;
      return f;
    })();
    fontCache[family] = p;
    try { var f = await p; fontCache[family] = f; return f; }
    catch (e) { delete fontCache[family]; throw e; }
  }

  // css2-loaded fonts only hold the latin subset. For characters outside it, load the subsets whose
  // unicode-range covers them (latin-ext, vietnamese, …). Resolves to the fonts newly added.
  async function loadSubsetsFor(family, codes) {
    var faces = await css2Faces(family);
    var want = faces.filter(function (f) {
      return f.subset !== 'latin' && codes.some(function (c) {
        return f.ranges.some(function (r) { return c >= r[0] && c <= r[1]; });
      });
    });
    var got = [];
    for (var i = 0; i < want.length; i++) {
      var k = family + '|' + want[i].url;
      if (!subsetCache[k]) {
        subsetCache[k] = woff2Font(want[i].url).then(function (buf) { return opentype.parse(buf); });
        subsetCache[k].catch((function (kk) { return function () { delete subsetCache[kk]; }; })(k));
      }
      try { got.push(await subsetCache[k]); } catch (e) {}
    }
    return got;
  }

  var coverageKey = '', coverageBusy = '';
  function checkCoverage(missing) {
    var name = state.fontName;
    var key = name + '|' + missing.join('');
    if (!missing.length || key === coverageKey || key === coverageBusy) return;
    var custom = name.indexOf('My font: ') === 0;
    var warn = function (chars) {
      if (state.fontName !== name || !chars.length) return;
      coverageKey = key;
      toast('Some characters aren’t in ' + name.replace(/^My font: /, '') + ': ' + chars.join(' ') + '. Try another font.');
      track('missing_glyphs', { font_name: custom ? 'uploaded' : name, chars: chars.join('').slice(0, 40) });
    };
    if (custom || fontSrc[name] !== 'css2') { warn(missing); return; }
    coverageBusy = key;
    loadSubsetsFor(name, missing.map(function (c) { return c.codePointAt(0); })).then(function (fonts) {
      coverageBusy = '';
      if (state.fontName !== name || !state.font) return;
      var added = fonts.filter(function (f) { return state.fontExtras.indexOf(f) === -1; });
      if (added.length) {
        state.fontExtras = state.fontExtras.concat(added);   // the re-render re-checks what's still missing
        weldCache = { d: '', key: '' };
        render();
        return;
      }
      warn(missing.filter(function (c) { return glyphFor(c).g.index === 0; }));
    }, function () { coverageBusy = ''; warn(missing); });
  }

  /* ---------------- layout: glyph geometry in stage px ---------------- */
  function capHeightPx(font) {
    var upm = font.unitsPerEm;
    var os2 = font.tables && font.tables.os2;
    if (os2 && os2.sCapHeight) return os2.sCapHeight / upm * FS;
    try {
      var bb = font.charToGlyph('H').getPath(0, 0, FS).getBoundingBox();
      var h = bb.y2 - bb.y1;
      if (h > 0) return h;
    } catch (e) {}
    return (font.ascender / upm * FS) * 0.72;
  }

  // Many Google Fonts builds keep overlapping contours inside one glyph (e.g. Inter/Montserrat "A", "4").
  // Self-union once so each glyph is a clean outline (real counters kept, correctly wound for nonzero).
  // If the union ever changes the filled shape (rare paper.js edge case), keep the raw outline instead.
  var cleanCache = new WeakMap();  // opentype.Font -> Map(glyphIndex -> cleaned d at x=0)
  function sameFill(a, b) {
    var bb = a.bounds, N = 40, miss = 0;
    for (var i = 0; i < N; i++) for (var j = 0; j < N; j++) {
      var pt = new paper.Point(bb.x + (i + 0.4731) * bb.width / N, bb.y + (j + 0.5279) * bb.height / N);
      if (a.contains(pt) !== b.contains(pt) && ++miss > 2) return false;
    }
    return true;
  }
  function cleanOutline(d) {
    if (!d) return d;
    try {
      ensurePaper();
      var cp = new paper.CompoundPath({ pathData: d, insert: false });
      var u = cp.unite(cp, { insert: false });
      var ud = u && u.getPathData(null, 3);
      if (ud && sameFill(cp, u)) return ud;
    } catch (e) {}
    return d;
  }
  function glyphD(font, g, x) {
    var m = cleanCache.get(font);
    if (!m) { m = new Map(); cleanCache.set(font, m); }
    var d0 = m.get(g.index);
    if (d0 === undefined) { d0 = cleanOutline(g.getPath(0, 0, FS).toPathData(3)); m.set(g.index, d0); }
    if (!d0 || !x) return d0;
    try {
      var cp = new paper.CompoundPath({ pathData: d0, insert: false });
      cp.translate(new paper.Point(x, 0));
      return cp.getPathData(null, 3);
    } catch (e) { return g.getPath(x, 0, FS).toPathData(3); }
  }

  // Main font first; a glyph it lacks (index 0) comes from an extra subset font if one has it.
  function glyphFor(ch) {
    var g = state.font.charToGlyph(ch);
    if (g.index === 0) {
      for (var k = 0; k < state.fontExtras.length; k++) {
        var g2 = state.fontExtras[k].charToGlyph(ch);
        if (g2.index !== 0) return { f: state.fontExtras[k], g: g2 };
      }
    }
    return { f: state.font, g: g };
  }
  var lastMissing = [];
  function layoutLetters() {
    var font = state.font;
    lastMissing = [];
    if (!font) return [];
    var letters = [];
    var x = 0, prev = null, prevF = null;
    for (var i = 0; i < state.text.length; i++) {
      var ch = state.text[i];
      var fg = glyphFor(ch), f = fg.f, g = fg.g;
      var upm = f.unitsPerEm, scale = FS / upm;
      if (prev && prevF === f) x += (f.getKerningValue(prev, g) || 0) * scale;
      if (g.index === 0 && !/\s/.test(ch) && lastMissing.indexOf(ch) === -1) lastMissing.push(ch);
      var off = state.offsets[i] || { dx: 0, dy: 0 };
      var d = '';
      if (ch !== ' ') d = glyphD(f, g, x);
      letters.push({ i: i, ch: ch, d: d, dx: off.dx, dy: off.dy });
      x += (g.advanceWidth || upm * 0.3) * scale + state.spacing;
      prev = g; prevF = f;
    }
    return letters;
  }

  function splitParts(d) {
    if (!d) return [];
    return d.split(/(?=M)/i).filter(function (s) { return s.trim().length > 2; });
  }
  function letterActiveD(L) {
    return splitParts(L.d).filter(function (_, pi) { return !state.disabledParts.has(L.i + ':' + pi); }).join('');
  }

  /* ---------------- welding ---------------- */
  var paperReady = false;
  function ensurePaper() {
    if (paperReady) return;
    paper.setup(document.createElement('canvas'));
    paperReady = true;
  }
  function computeWeld(letters) {
    var key = JSON.stringify([state.text, state.fontName, state.spacing,
      letters.map(function (l) { return [l.dx, l.dy]; }), Array.from(state.disabledParts)]);
    if (weldCache.key === key) return weldCache.d;
    ensurePaper();
    paper.project.clear();
    var acc = null;
    letters.forEach(function (L) {
      var d = letterActiveD(L);
      if (!d) return;
      var cp;
      try { cp = new paper.CompoundPath(d); } catch (e) { return; }
      cp.fillRule = 'nonzero';
      cp.translate(new paper.Point(L.dx, L.dy));
      if (!acc) { acc = cp; }
      else {
        var u = acc.unite(cp, { insert: false });
        acc.remove(); cp.remove();
        acc = u;
      }
    });
    var out = acc ? acc.pathData : '';
    paper.project.clear();
    weldCache = { key: key, d: out };
    return out;
  }

  /* ---------------- physical scale ---------------- */
  function physScale(bbox) {
    var targetPx = unitToIn(state.sizeVal, state.sizeUnit) * 96;
    var base = state.sizeMode === 'cap' ? capHeightPx(state.font) : (bbox.h || 1);
    var k = targetPx / (base || 1);
    return { kx: k * state.sx, ky: k * state.sy };
  }

  /* ---------------- bbox from path data (hidden svg) ---------------- */
  var measureSvg = document.createElementNS(SVGNS, 'svg');
  measureSvg.setAttribute('aria-hidden', 'true');
  measureSvg.setAttribute('style', 'position:absolute;left:-9999px;top:0;width:0;height:0;overflow:hidden;');
  document.body.appendChild(measureSvg);
  function bboxOf(letters) {
    measureSvg.innerHTML = '';
    var g = document.createElementNS(SVGNS, 'g');
    letters.forEach(function (L) {
      var d = letterActiveD(L);
      if (!d) return;
      var p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('transform', 'translate(' + L.dx + ' ' + L.dy + ')');
      g.appendChild(p);
    });
    measureSvg.appendChild(g);
    var b = g.getBBox();
    return { x: b.x, y: b.y, w: b.width, h: b.height };
  }

  /* ---------------- render ---------------- */
  var stage = $('fc-stage');
  var dims = $('fc-dims');
  var dlBtn = $('fc-download');
  function setExportEnabled(on) { dlBtn.disabled = !on; }

  function render() {
    var font = state.font;
    stage.innerHTML = '';
    if (!font) { dims.textContent = 'Pick a font to begin'; setExportEnabled(false); return; }
    if (!state.text.trim()) { dims.textContent = 'Type some text in step 1'; setExportEnabled(false); return; }

    var letters = layoutLetters();
    checkCoverage(lastMissing);
    var bb = bboxOf(letters);
    if (bb.w === 0 && bb.h === 0) { dims.textContent = '—'; setExportEnabled(false); return; }
    setExportEnabled(true);
    var ph = physScale(bb);

    var sxv = state.sx, syv = state.sy;
    var vx = bb.x * sxv, vy = bb.y * syv, vw = bb.w * sxv, vh = bb.h * syv;
    var pad = Math.max(vw, vh) * 0.08 + 40;
    stage.setAttribute('viewBox', (vx - pad) + ' ' + (vy - pad) + ' ' + (vw + pad * 2) + ' ' + (vh + pad * 2));
    stage.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    var world = document.createElementNS(SVGNS, 'g');
    world.setAttribute('id', 'fc-world');
    world.setAttribute('transform', 'scale(' + sxv + ' ' + syv + ')');
    stage.appendChild(world);

    if (state.view === 'weld') {
      var p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('d', computeWeld(letters));
      p.setAttribute('fill', '#1F1A1C');
      p.setAttribute('fill-rule', 'nonzero');
      world.appendChild(p);
    } else if (state.view === 'parts') {
      var on = accent();
      letters.forEach(function (L) {
        if (!L.d) return;
        var g = document.createElementNS(SVGNS, 'g');
        g.setAttribute('transform', 'translate(' + L.dx + ' ' + L.dy + ')');
        var base = document.createElementNS(SVGNS, 'path');
        base.setAttribute('d', letterActiveD(L) || 'M0 0');
        base.setAttribute('fill', '#A7A1A4'); base.setAttribute('fill-rule', 'nonzero');
        g.appendChild(base);
        splitParts(L.d).forEach(function (pd, pi) {
          var key = L.i + ':' + pi;
          var off = state.disabledParts.has(key);
          var o = document.createElementNS(SVGNS, 'path');
          o.setAttribute('d', pd);
          o.setAttribute('class', 'fc-part');
          o.setAttribute('fill', 'rgba(0,0,0,0)');
          o.setAttribute('stroke', off ? '#D93A3A' : on);
          o.setAttribute('stroke-width', 6 / Math.max(sxv, syv));
          if (off) o.setAttribute('stroke-dasharray', '18 12');
          o.style.pointerEvents = 'all';
          o.addEventListener('click', function () {
            if (state.disabledParts.has(key)) state.disabledParts.delete(key);
            else state.disabledParts.add(key);
            track('hole_toggle', { removed: !off });
            render();
          });
          g.appendChild(o);
        });
        world.appendChild(g);
      });
    } else {
      letters.forEach(function (L) {
        if (!L.d) return;
        var g = document.createElementNS(SVGNS, 'g');
        g.setAttribute('class', 'fc-letter' + (state.selLetter === L.i ? ' sel' : ''));
        g.setAttribute('data-i', L.i);
        g.setAttribute('transform', 'translate(' + L.dx + ' ' + L.dy + ')');
        var p2 = document.createElementNS(SVGNS, 'path');
        p2.setAttribute('d', letterActiveD(L) || L.d);
        p2.setAttribute('fill', '#1F1A1C');
        p2.setAttribute('fill-rule', 'nonzero');
        g.appendChild(p2);
        world.appendChild(g);
      });
    }

    var win = bb.w * ph.kx / 96, hin = bb.h * ph.ky / 96;
    dims.textContent = 'Cuts at ' + fmt(win, state.sizeUnit) + ' wide × ' + fmt(hin, state.sizeUnit) + ' tall';
    $('fc-nudge').hidden = !(state.selLetter >= 0 && state.view === 'letters');
  }

  /* ---------------- dragging letters ---------------- */
  var drag = null, nudged = false;
  function noteNudge() { if (!nudged) { nudged = true; track('letter_nudge', {}); } }
  function worldPoint(e) {
    var world = stage.querySelector('#fc-world');
    if (!world) return null;
    var m = world.getScreenCTM().inverse();
    return new DOMPoint(e.clientX, e.clientY).matrixTransform(m);
  }
  stage.addEventListener('pointerdown', function (e) {
    if (state.view !== 'letters') return;
    var g = e.target.closest('.fc-letter');
    if (!g) { if (state.selLetter >= 0) { state.selLetter = -1; render(); } return; }
    var i = +g.dataset.i;
    state.selLetter = i;
    var pt = worldPoint(e);
    if (!pt) return;
    var off = state.offsets[i] || { dx: 0, dy: 0 };
    drag = { i: i, startX: pt.x, startY: pt.y, dx0: off.dx, dy0: off.dy, moved: false };
    stage.setPointerCapture(e.pointerId);
    render();
  });
  stage.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var pt = worldPoint(e);
    if (!pt) return;
    state.offsets[drag.i] = { dx: drag.dx0 + (pt.x - drag.startX), dy: drag.dy0 + (pt.y - drag.startY) };
    drag.moved = true;
    render();
  });
  function endDrag() { if (drag && drag.moved) noteNudge(); drag = null; }
  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);

  /* nudge pad (touch-friendly) */
  function nudgeSel(dx, dy) {
    if (state.selLetter < 0) return;
    var o = state.offsets[state.selLetter] || { dx: 0, dy: 0 };
    o.dx += dx; o.dy += dy;
    state.offsets[state.selLetter] = o;
    noteNudge();
    render();
  }
  root.querySelectorAll('#fc-nudge button[data-dx]').forEach(function (b) {
    var dx = +b.dataset.dx, dy = +b.dataset.dy;
    var t = null, iv = null;
    var start = function (e) {
      e.preventDefault(); e.stopPropagation();
      nudgeSel(dx, dy);
      t = setTimeout(function () { iv = setInterval(function () { nudgeSel(dx, dy); }, 60); }, 350);
    };
    var stop = function () { clearTimeout(t); clearInterval(iv); t = iv = null; };
    b.addEventListener('pointerdown', start);
    b.addEventListener('pointerup', stop);
    b.addEventListener('pointercancel', stop);
    b.addEventListener('pointerleave', stop);
  });
  $('fc-nudgeClose').addEventListener('click', function () { state.selLetter = -1; render(); });

  document.addEventListener('keydown', function (e) {
    if (/INPUT|SELECT|TEXTAREA|BUTTON/.test(e.target.tagName) || e.target.isContentEditable) return;
    if (document.querySelector('.bt-proc')) return;
    if (state.selLetter < 0 || state.view !== 'letters') return;
    var step = e.shiftKey ? 40 : 8;
    var off = state.offsets[state.selLetter] || { dx: 0, dy: 0 };
    var used = true;
    if (e.key === 'ArrowLeft') off.dx -= step;
    else if (e.key === 'ArrowRight') off.dx += step;
    else if (e.key === 'ArrowUp') off.dy -= step;
    else if (e.key === 'ArrowDown') off.dy += step;
    else if (e.key === 'Escape') { state.selLetter = -1; render(); return; }
    else used = false;
    if (used) { state.offsets[state.selLetter] = off; e.preventDefault(); noteNudge(); render(); }
  });

  /* ---------------- export ---------------- */
  function buildExportSVG() {
    var letters = layoutLetters();
    var bb = bboxOf(letters);
    var ph = physScale(bb);
    var Wpx = bb.w * ph.kx, Hpx = bb.h * ph.ky;
    var Win = Wpx / 96, Hin = Hpx / 96;
    var tx = -bb.x * ph.kx, ty = -bb.y * ph.ky;
    var inner;
    if ($('fc-weld').checked) {
      inner = '<path d="' + computeWeld(letters) + '" fill="#000000" fill-rule="nonzero"/>';
    } else {
      inner = letters.filter(function (L) { return letterActiveD(L); }).map(function (L) {
        return '<g transform="translate(' + L.dx + ' ' + L.dy + ')"><path d="' + letterActiveD(L) + '" fill="#000000" fill-rule="nonzero"/></g>';
      }).join('');
    }
    return '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + Win.toFixed(4) + 'in" height="' + Hin.toFixed(4) + 'in" viewBox="0 0 ' + Wpx.toFixed(2) + ' ' + Hpx.toFixed(2) + '">\n' +
      '<g transform="translate(' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ') scale(' + ph.kx.toFixed(5) + ' ' + ph.ky.toFixed(5) + ')">' + inner + '</g>\n</svg>';
  }
  function fileName() {
    var safe = state.text.trim().replace(/[^\w-]+/g, '-').slice(0, 30) || 'text';
    return safe + '-' + state.fontName.replace(/^My font: /, '').replace(/[^\w-]+/g, '') + ' - BA.svg';
  }
  function exportProps() {
    return {
      font_name: state.fontName.indexOf('My font: ') === 0 ? 'uploaded' : state.fontName,
      chars: state.text.trim().length,
      weld: $('fc-weld').checked,
      size: state.sizeVal + ' ' + state.sizeUnit,
      nudged: Object.keys(state.offsets).length > 0,
      holes_removed: state.disabledParts.size
    };
  }
  function saveFile(svg, name) {
    if (window.BT && window.BT.trueSize) svg = window.BT.trueSize(svg); // 72 units/in for Design Space
    var blob = new Blob([svg], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.rel = 'noopener';
    if ('download' in a) {
      a.download = (window.BT && BT.brandName ? BT.brandName(name) : name);
      document.body.appendChild(a); // required for iOS Safari/Chrome
      a.click();
      a.remove();
    } else {
      window.open(url, '_blank');
    }
    setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
  }

  /* ---------------- download popup (shared: BT.runWithProgress in the core) ---------------- */
  function exportReady() { return !!state.font && !!state.text.trim(); }

  function runWithProgress(work, doneText) {
    if (document.querySelector('.bt-proc')) return;   // popup already open
    setExportEnabled(false);
    if (window.BT && window.BT.runWithProgress) {
      window.BT.runWithProgress({
        stages: [
          { p: 22, wait: 350, text: 'Tracing your letters…' },
          { p: 58, wait: 800, text: 'Welding the overlaps…' },
          { p: 84, wait: 800, text: 'Sizing it for your mat…' }
        ],
        gateText: 'Your file is almost ready! Enter your email to get it.',
        doneText: doneText || 'Your file is ready!',
        errorText: 'Sorry, the file couldn’t be saved. Please try again.',
        work: work,
        onEnd: function () { setExportEnabled(exportReady()); }
      });
      return;
    }
    // old core cached: no popup, just export
    Promise.resolve().then(work).catch(function () {
      toast('Sorry, the file couldn’t be saved. Please try again.');
    }).then(function () { setExportEnabled(exportReady()); });
  }

  dlBtn.addEventListener('click', function () {
    if (!state.font) { showMsg('Pick a font first.'); return; }
    var svg = buildExportSVG(), name = fileName(), props = exportProps();
    runWithProgress(function () {
      saveFile(svg, name);
      track('download_click', Object.assign({ file_name: name, method: 'download' }, props));
      klaviyoEvent('Used ' + TOOL.name, Object.assign({ method: 'download' }, props));
    });
  });

  /* ---------------- font browser ---------------- */
  var listEl = $('fc-list');
  var tagBar = $('fc-tags');

  function buildTagBar() {
    Object.keys(TAGS).forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'fc-tag'; b.textContent = TAGS[k]; b.dataset.tag = k;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        activeTag = activeTag === k ? '' : k;           // one style at a time; tap again to show all
        tagBar.querySelectorAll('.fc-tag').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x.dataset.tag === activeTag));
        });
        if (activeTag) track('tag_filter', { tag: k });
        buildList();
        listEl.scrollTop = 0;
      });
      tagBar.appendChild(b);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var fam = en.target.dataset.fam;
      if (fam && !linkLoaded.has(fam)) {
        linkLoaded.add(fam);
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = 'https://fonts.googleapis.com/css2?family=' + fam.replace(/ /g, '+') + '&display=swap';
        document.head.appendChild(l);
      }
      io.unobserve(en.target);
    });
  }, { root: listEl, rootMargin: '200px' });

  function buildList() {
    var q = $('fc-search').value.trim().toLowerCase();
    listEl.innerHTML = '';
    var items = state.customFonts.map(function (c) { return { n: c.n, t: ['uploaded'], custom: true }; })
      .concat(FONTS)
      .filter(function (f) {
        if (q && f.n.toLowerCase().indexOf(q) === -1) return false;
        if (activeTag && !f.custom && f.t.indexOf(activeTag) === -1) return false;
        return true;
      });
    var prevText = esc((state.text.trim() || 'Hello').slice(0, 26));
    items.forEach(function (f) {
      var card = document.createElement('div');
      card.className = 'fc-card' + (f.n === state.fontName ? ' sel' : '');
      card.setAttribute('role', 'option');
      card.setAttribute('aria-selected', String(f.n === state.fontName));
      card.tabIndex = 0;
      card.dataset.fam = f.custom ? '' : f.n;
      card.dataset.name = f.n;
      var tagLine = f.custom ? 'your upload' : f.t.map(function (t) { return TAGS[t]; }).join(' · ').toLowerCase();
      card.innerHTML = '<div class="fc-card__name">' + esc(f.n) + ' — ' + esc(tagLine) + '</div>' +
        '<div class="fc-card__prev" style="font-family:\'' + esc(f.n) + '\',sans-serif;">' + prevText + '</div>';
      var pick = function () { selectFont(f.n, f.custom, true); };
      card.addEventListener('click', pick);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      listEl.appendChild(card);
      if (!f.custom) io.observe(card);
    });
    if (!items.length) {
      listEl.innerHTML = '<div class="fc-empty">No fonts match. Clear the style filter or try another word.</div>';
    }
  }

  // Only refresh the preview text on existing cards (keeps scroll position while typing).
  function refreshPreviews() {
    var t = (state.text.trim() || 'Hello').slice(0, 26);
    listEl.querySelectorAll('.fc-card__prev').forEach(function (el) { el.textContent = t; });
  }

  async function selectFont(name, custom, fromUser) {
    state.fontName = name;
    listEl.querySelectorAll('.fc-card').forEach(function (c) {
      var on = c.dataset.name === name;
      c.classList.toggle('sel', on);
      c.setAttribute('aria-selected', String(on));
    });
    if (fromUser) {
      track('font_selected', { font_name: custom ? 'uploaded' : name, source: custom ? 'upload' : 'catalog', tag: activeTag || 'all' });
      markStarted({ font_name: custom ? 'uploaded' : name });
      // Most people browse fonts and leave before the Download step. Once they've picked one,
      // point at it.
      if (window.BT && BT.nudge) BT.nudge('download', {
        text: 'Happy with that font? Your cut file is ready to download.',
        action: 'Download', delay: 4000,
        when: function () { return !dlBtn.disabled; },
        onAction: function () { BT.goToDownload(dlBtn); }
      });
    }
    if (custom) {
      var c = state.customFonts.find(function (x) { return x.n === name; });
      state.font = c.font;
      resetPerFontState();
      render();
      return;
    }
    var card = Array.prototype.find.call(listEl.children, function (c2) { return c2.dataset.fam === name; });
    var spin = document.createElement('span');
    spin.className = 'fc-card__spin'; spin.textContent = 'loading…';
    if (card) card.appendChild(spin);
    try {
      var f = await loadFont(name);
      if (state.fontName !== name) return;            // a newer pick won
      state.font = f;
      resetPerFontState();
      render();
    } catch (e) {
      track('font_load_error', { font_name: name });
      showMsg('Couldn’t load ' + name + ' in this browser. Try another font, or upload the font file in step 2.');
      if (state.fontName === name) render();          // clear "Loading fonts…" (keeps any font already shown)
    } finally {
      spin.remove();
    }
  }

  function resetPerFontState() {
    state.fontExtras = [];
    coverageKey = '';
    state.disabledParts.clear();
    state.selLetter = -1;
    weldCache = { d: '', key: '' };
  }

  /* ---------------- upload ---------------- */
  var upInput = $('fc-uploadInput');
  $('fc-upload').addEventListener('click', function () { upInput.click(); });
  upInput.addEventListener('change', async function (e) {
    var file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    track('file_upload', { file_type: (file.name.split('.').pop() || '').toLowerCase(), file_kb: Math.round(file.size / 1024) });
    try {
      var buf = await file.arrayBuffer();
      var font = opentype.parse(buf);
      var name = 'My font: ' + file.name.replace(/\.(ttf|otf)$/i, '');
      state.customFonts.unshift({ n: name, font: font });
      try { var ff = new FontFace(name, buf); await ff.load(); document.fonts.add(ff); } catch (err) {}
      buildList();
      listEl.scrollTop = 0;
      selectFont(name, true, true);
      toast('Font loaded. Check its license allows the products you make.');
    } catch (err) {
      showMsg('That file couldn’t be read as a font. Use a .ttf or .otf file.');
    }
  });

  /* ---------------- controls ---------------- */
  var textTimer = null;
  $('fc-text').addEventListener('input', function (e) {
    state.text = e.target.value;
    state.offsets = {}; state.disabledParts.clear(); state.selLetter = -1;
    refreshPreviews(); render();
    clearTimeout(textTimer);
    textTimer = setTimeout(function () { track('text_edit', { chars: state.text.trim().length }); markStarted({ font_name: state.fontName }); }, 1500);
  });
  $('fc-search').addEventListener('input', buildList);
  $('fc-size').addEventListener('input', function (e) { state.sizeVal = +e.target.value || 0.1; render(); });
  $('fc-unit').addEventListener('change', function (e) { state.sizeUnit = e.target.value; render(); });
  $('fc-mode').addEventListener('change', function (e) { state.sizeMode = e.target.value; render(); });
  $('fc-spacing').addEventListener('input', function (e) {
    state.spacing = +e.target.value;
    $('fc-spacingVal').textContent = state.spacing === 0 ? 'normal' : (state.spacing > 0 ? '+' : '') + state.spacing;
    render();
  });
  $('fc-sx').addEventListener('input', function (e) { state.sx = +e.target.value / 100; $('fc-sxVal').textContent = e.target.value + '%'; render(); });
  $('fc-sy').addEventListener('input', function (e) { state.sy = +e.target.value / 100; $('fc-syVal').textContent = e.target.value + '%'; render(); });
  $('fc-resetNudge').addEventListener('click', function () { state.offsets = {}; state.selLetter = -1; render(); });

  var HINTS = {
    letters: 'Drag a letter to nudge it. Arrow keys work too.',
    weld: 'Overlaps merged into one clean shape — this is what exports.',
    parts: 'Click any outlined piece to remove it (fill a hole or knock out a shape). Click again to restore.'
  };
  var viewSeg = $('fc-view');
  viewSeg.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !viewSeg.contains(b)) return;
    viewSeg.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    if (state.view === b.value) return;
    state.view = b.value;
    $('fc-viewhint').textContent = HINTS[state.view];
    track('view_change', { view: state.view });
    render();
  });

  /* ---------------- backup route: API key modal ---------------- */
  var keyModal = $('fc-keyModal');
  $('fc-keyOpen').addEventListener('click', function () { $('fc-keyInput').value = getKey(); keyModal.hidden = false; $('fc-keyInput').focus(); });
  $('fc-keyClose').addEventListener('click', function () { keyModal.hidden = true; });
  $('fc-keySave').addEventListener('click', function () {
    setKey($('fc-keyInput').value.trim());
    keyModal.hidden = true;
    toast('Saved. Pick the font again to retry.');
  });
  keyModal.addEventListener('click', function (e) { if (e.target === keyModal) keyModal.hidden = true; });

  /* ---------------- boot ---------------- */
  buildTagBar();
  buildList();
  (function waitForLibs(tries) {
    if (libsReady()) { selectFont(state.fontName, false, false); return; }
    if (tries > 150) { dims.textContent = 'Couldn’t start — please refresh the page.'; return; }
    setTimeout(function () { waitForLibs(tries + 1); }, 100);
  })(0);
})();